import type { ReturnTypeUseMailSearch } from '../api/mail-search';

export enum MailTypeMessage {
  BROADCAST = 'BROADCAST',
  GROUP = 'GROUP',
}

export interface ComposeMailFormValues {
  subject: string;
  canReply: boolean;
  typeMessage: MailTypeMessage;
  toRecipients: ReturnTypeUseMailSearch[];
  partyId: number;
}
